import { render, staticRenderFns } from "./LotteryModalAnimation.vue?vue&type=template&id=472d0f08&scoped=true"
import script from "./LotteryModalAnimation.vue?vue&type=script&lang=js"
export * from "./LotteryModalAnimation.vue?vue&type=script&lang=js"
import style0 from "./LotteryModalAnimation.vue?vue&type=style&index=0&id=472d0f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d0f08",
  null
  
)

export default component.exports